// How things move: one duration and one easing for every animation, and the
// person's reduced-motion preference, which turns them into instant changes.

const MOTION_MS = 200;
const MOTION_EASE = "cubic-bezier(0.2, 0, 0, 1)";

function prefersReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true
  );
}

/** How long an animation runs: none when motion is reduced. */
export const motionMs = (): number => (prefersReducedMotion() ? 0 : MOTION_MS);

/** A CSS `transition` over `properties`, or `none` when motion is reduced. */
export function motionTransition(...properties: string[]): string {
  const ms = motionMs();
  return ms === 0 ? "none" : properties.map((p) => `${p} ${ms}ms ${MOTION_EASE}`).join(", ");
}
